$('.block-legacy-card-slider').each(function() {

	const slider = $(this);
	const controls = slider.find('.swiper-controls');
	const desktopTarget = slider.closest('.wp-block-columns').find('.js-desktop-controls');
	const originalAnchor = controls.next();

	let swiper = null;

	function initSwiper() {
		if (swiper) swiper.destroy(true, true);
		swiper = new Swiper(slider.find('.swiper')[0], {
			centeredSlides: true,
			loop: true,
			navigation: {
				nextEl: controls.find('.swiper-arrow.next')[0],
				prevEl: controls.find('.swiper-arrow.prev')[0],
			},
			slidesPerView: 1.3,
			spaceBetween: 16,
			speed: 500,
			breakpoints: {
				782: {
					centeredSlides: false,
					slidesPerView: 1.3,
					spaceBetween: 30,
				}
			}
		});
	}

	function repositionControls(isDesktop) {
		if (isDesktop) {
			controls.appendTo(desktopTarget);
		} else {
			controls.insertBefore(originalAnchor);
		}
		initSwiper();
	}

	const mq = window.matchMedia('(min-width: 782px)');
	repositionControls(mq.matches);
	mq.addEventListener('change', (e) => repositionControls(e.matches));

});
